<template>
    <transition name="letter-fade">
        <div v-if="showLetter" class="show-letter-overlay" @click.self="showLetter = false">
            <div class="show-letter">

                <div class="show-letter__body">
                    <div class="letter-image-wrap">
                        <img :src="letterUrl" alt="保密承诺书" class="letter-image">
                        <div class="letter-watermark" v-if="hotelName">{{ hotelName }}</div>
                    </div>
                </div>

                <div class="show-letter__footer">
                    <button @click="showLetter = false" class="close-button">我已知晓</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { getAssociationID } from '../../auth/getAssociationId'
import { getHotelName } from '../../auth/getHotelName'



const showLetter = ref(false)
const letterUrl = ref('')
const hotelName = ref('')

onMounted(async () => {
    const associationID = await getAssociationID()
    console.log("associationID", associationID, associationID == 3606)
    hotelName.value = await getHotelName()
    console.log("hotelName", hotelName.value)
    hotelName.value = hotelName.value || ""
    if(associationID == 3606){
        letterUrl.value = `/images/保密承诺书.jpg`
        const letterHasBeenShown = localStorage.getItem('ndaShownV1')
        if(!letterHasBeenShown){
            showLetter.value = true
            localStorage.setItem('ndaShownV1', 'true')
        }
    }
})



</script>

<style scoped>
.show-letter-overlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
    background: rgba(15, 23, 42, 0.55);
    backdrop-filter: blur(10px);
    z-index: 9999;
}

.show-letter {
    width: min(900px, 100%);
    max-height: min(88vh, 1000px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(148, 163, 184, 0.22);
    border-radius: 24px;
    box-shadow: 0 24px 80px rgba(15, 23, 42, 0.24);
}

.show-letter__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 24px 12px;
}

.show-letter__title-wrap {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.show-letter__eyebrow {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #64748b;
}

.show-letter__title {
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
}

.show-letter__body {
    flex: 1;
    height: 500px;
    min-height: 500px;
    max-height: 500px;
    width: 100%;
    padding: 0 24px;
    overflow-y: auto;
    overflow-x: hidden;
}

.letter-image-wrap {
    position: relative;
    width: 100%;
    height: 800px;
    min-height: 800px;
    max-height: 800px;
}

.letter-image {
    width: 100%;
    height: 800px;
    min-height: 800px;
    max-height: 800px;
    object-fit: contain;
    border-radius: 16px;
    background: #fff;
    box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.2);
}

.letter-watermark {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
    color: rgba(161, 44, 40, 0.18);
    font-size: clamp(28px, 4vw, 48px);
    font-weight: 700;
    letter-spacing: 0.18em;
    text-align: center;
    transform: rotate(-18deg);
    pointer-events: none;
    user-select: none;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.35);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.show-letter__footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px 24px;
}

.close-button,
.close-icon {
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
}

.close-button {
    min-width: 120px;
    height: 44px;
    padding: 0 20px;
    border-radius: 999px;
    background: linear-gradient(135deg, #a12c28 0%, #c2413b 100%);
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    box-shadow: 0 10px 24px rgba(161, 44, 40, 0.28);
}

.close-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 14px 28px rgba(161, 44, 40, 0.32);
}

.close-icon {
    width: 36px;
    height: 36px;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.14);
    color: #334155;
    font-size: 16px;
    line-height: 1;
}

.close-icon:hover {
    background: rgba(148, 163, 184, 0.24);
}

.letter-fade-enter-active,
.letter-fade-leave-active {
    transition: opacity 0.28s ease, transform 0.28s ease;
}

.letter-fade-enter-from,
.letter-fade-leave-to {
    opacity: 0;
}

.letter-fade-enter-from .show-letter,
.letter-fade-leave-to .show-letter {
    transform: translateY(12px) scale(0.98);
}

@media (max-width: 768px) {
    .show-letter-overlay {
        padding: 16px;
    }

    .show-letter {
        max-height: 92vh;
        border-radius: 20px;
    }

    .show-letter__header,
    .show-letter__body,
    .show-letter__footer {
        padding-left: 16px;
        padding-right: 16px;
    }

    .show-letter__title {
        font-size: 22px;
    }

    .letter-image {
        max-height: calc(92vh - 172px);
    }

    .letter-image-wrap {
        max-height: calc(92vh - 172px);
        min-height: unset;
        height: calc(92vh - 172px);
    }

    .letter-watermark {
        font-size: clamp(20px, 5vw, 32px);
        letter-spacing: 0.12em;
        padding: 16px;
    }
}
</style>
